const errorClass = `
  active:outline-error-l80-white
  focus:outline-error-l80-white
  border-error-l20
  bg-grey-l100
`

const successClass = `
  active:outline-success-l80-white
  focus:outline-success-l80-white
  border-success-l20
  bg-grey-l100
`
const disabledClass = `
  border-grey-l60
  bg-grey-l80
  text-grey-l20
  pointer-events-none
`
export const getDisabled = (
  error: boolean,
  success: boolean,
  disabled = true
): string => {
  if (error && disabled) {
    return `${errorClass} ${disabledClass}`
  }
  if (error && success) {
    return `${successClass} ${disabledClass}`
  }
  if (error) {
    return errorClass
  }
  return disabledClass
}

const defaultClass = `
  hover:border-interactive-l60
  active:border-interactive-l60
  active:outline-interactive-l80
  focus:border-interactive-l60
  focus:outline-interactive-l80
  border-grey-l60
  bg-grey-l100
  focus:bg-grey-l100
`

export const getDefault = (error: boolean, success: boolean): string => {
  if (error) {
    return errorClass
  }
  if (success) {
    return successClass
  }
  return defaultClass
}
